import { all, fork } from 'redux-saga/effects';
import categorySaga from './category/categorySaga';


export default function* megaSagas() {
	yield all([fork(categorySaga)]);
}
